import React from 'react';

import { FooterContainer } from './styledComponents';

export const TableFormFooter = (props) => <FooterContainer>{props.children}</FooterContainer>;
